import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { getIdData } from "../../../lib/studentinfo";
import InstructorStudentActivitiesAndAwardsList from "./activitiesandawards";
import Student12TopMenu from "../studentInfo/student12topmenu"
import Student911TopMenu from "../studentInfo/student911topmenu"
import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";

export default function InstructorStudentActivitiesAndAwardsIndex() {
  let { slug } = useParams();
  const [isStudent911, setisStudent911] = useState(false);
  const [isStudent12, setisStudent12] = useState(false);
  const { profile, setProfile } = useAuth();

  async function GetData() {
    const info = await getIdData(slug);
    if (info[0].role === "Student911") {
      setisStudent911(true);
    } else if (info[0].role === "Student12") {
      setisStudent12(true);
    }
  }
   
    useEffect(() => {
      GetData();
    }, []);
  return (
    <>
      {isStudent911 && (
        <Student911TopMenu slug={slug} activeMenu={"Activities/Awards"} />
      )}
      {isStudent12 && (
        <Student12TopMenu slug={slug} activeMenu={"Activities/Awards"} />
      )}
      <PageNotes
        type={"Instructor"}
        pageName={"Activities/Awards"}
        studentId={slug}
        instructorId={profile.id}
      />
      <InstructorStudentActivitiesAndAwardsList />
    </>
  );
}